import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AppNotification } from '../../models/notification';
import { Page } from '../../models/page';

@Injectable({
  providedIn: 'root',
})
export class NotificationsHttpService {
  private static readonly baseurl = environment.baseurl;
  private readonly httpClient = inject(HttpClient);

  /**
   * Notification history, newest first — the opposite of the SSE stream, which replays
   * oldest first so events arrive in the order they happened.
   */
  getNotifications(query: { unreadOnly?: boolean; page: number; size: number }) {
    let params = new HttpParams().set('page', query.page).set('size', query.size);
    if (query.unreadOnly) params = params.set('unreadOnly', true);

    return this.httpClient.get<Page<AppNotification>>(
      `${NotificationsHttpService.baseurl}/api/notifications/list`,
      { params },
    );
  }

  /**
   * Marks one notification read. On a role broadcast this clears it for **every** holder of
   * that role, not just the current user, so it must only ever be called from an explicit
   * user action — never on render.
   */
  markAsRead(id: string) {
    return this.httpClient.patch<void>(
      `${NotificationsHttpService.baseurl}/api/notifications/${id}/read`,
      null,
    );
  }

  /** Also shared: deleting a role broadcast removes it for everyone in that role. */
  deleteNotification(id: string) {
    return this.httpClient.delete<void>(
      `${NotificationsHttpService.baseurl}/api/notifications/${id}`,
    );
  }
}
